// src/features/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { settingService } from '../services/api/setting.service';
import { walletService } from '../services/api/wallet.service';
import { cardService } from '../services/api/card.service';
import { walletTransactionService } from '../services/api/wallet-transaction.service';
export const getExchangeRates = createAsyncThunk('data/fetchExchangeRates', async () => {
  try{
    // OPTIMIZATION: Smart caching para exchange rates
    // Los exchange rates no cambian constantemente, podemos cachearlos por 5 minutos
    const CACHE_KEY = 'exchange-rates-cache';
    const CACHE_TIMESTAMP_KEY = 'exchange-rates-timestamp';
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

    const cachedData = localStorage.getItem(CACHE_KEY);
    const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);

    if (cachedData && cachedTimestamp) {
      const timestamp = parseInt(cachedTimestamp, 10);
      const now = Date.now();
      if (now - timestamp < CACHE_DURATION) {
        return JSON.parse(cachedData);
      }
    }

    // Hacer ambas llamadas en paralelo con Promise.all para optimizar
    const [responseCryptodata, responseFiat] = await Promise.all([
      settingService.getCryptoCurrency(),
      settingService.getFiatCurrency()
    ]);

    const updatedCrypto = {
      ...responseCryptodata,
      USDT_ERC20: 1,
      USDT_TRON: 1,
      USDT_BEP20: 1
    };

    const result = { updatedCrypto, responseFiat, success: true };

    // Guardar en caché
    localStorage.setItem(CACHE_KEY, JSON.stringify(result));
    localStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString());

    return result;
  }
  catch(error) {
    console.error('❌ Error fetching exchange rates:', error);
    return {
      updatedCrypto: {
        BTC: 0,
        ETH: 0,
        USDT_ERC20: 0,
        TRX: 0,
        USDT_TRON: 0,
        BNB: 0,
        USDT_BEP20: 0,
      },
      responseFiat: {
        USD: 1.0, // Base 1.0
        EUR: 1,
        GBP: 1,
        AED: 1,
        MEX: 1,
        PAN: 1.0 // Balboa panameño tiene paridad con USD
      },
      success:false };
  }
});
export const getFiatPrices = createAsyncThunk('data/fetchFiatPrices', async () => {
  const response = await settingService.getFiatCurrency();
  return response;
});
export const getNetworkFees = createAsyncThunk('data/fetchNetworkFees', async (trxAddress:string) => {
  const btcFees = await walletTransactionService.getBitcoinFees();
  const ethFees = await walletTransactionService.getEthereumGasFees();
  console.log(trxAddress);
  let trxFees:any;
  if(trxAddress!=="0"){
    trxFees = await walletTransactionService.getTronFees(trxAddress);
  }else{
    trxFees = [];
  }
  const bnbFees = await walletTransactionService.getBnbFees();
  return {btcFees, ethFees, trxFees, bnbFees};
});
// export const getCryptoWallets = createAsyncThunk('data/fetchCryptoWallets', async () => {
//   const response = await walletService.getCryptoWallets();        
//   return response;
// });
// export const getMasterCardData = createAsyncThunk('data/fetchMasterCardData', async () => {
//   const response = await cardService.getMasterCardData();    
//   return response;
// });
// export const createCryptoWallet = createAsyncThunk('data/createCryptoWallet', async (currency:string) => {
//   const response = await walletService.createWallet(currency);   
//   return response;
// });
const settingSlice = createSlice({
  name: 'setting',
  initialState: {
    data: {
      cryptoPrices: {
        BTC: 0,
        ETH: 0,
        USDT_ERC20: 0,
        TRX: 0,
        USDT_TRON: 0,
        BNB: 0,
        USDT_BEP20: 0,
      },
      fiatPrices: {
        USD: 1.0, // Base 1.0
        EUR: 1,
        GBP: 1,
        AED: 1,
        MEX: 1,
        PAN: 1.0 // Balboa panameño tiene paridad con USD
      },
      networkFees:{
        btc:null,
        eth:null,
        trx:null,
        bnb:null
      }
    },
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExchangeRates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getExchangeRates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data.cryptoPrices = action.payload.updatedCrypto;
        state.data.fiatPrices = action.payload.responseFiat;
      })
      .addCase(getExchangeRates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
     
    .addCase(getNetworkFees.fulfilled, (state, action) => {
      state.data.networkFees.btc = action.payload.btcFees;
      state.data.networkFees.eth = action.payload.ethFees;
      state.data.networkFees.bnb = action.payload.bnbFees;
      state.data.networkFees.trx = action.payload.trxFees;
    })
    
    // .addCase(getFiatPrices.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(getFiatPrices.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   state.data.fiatPrices = action.payload;
    // })
    // .addCase(getFiatPrices.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error.message;
    // });
    //   .addCase(getMasterCardData.pending, (state) => {
    //     state.status = 'loading';
    //   })
    //   .addCase(getMasterCardData.fulfilled, (state, action) => {
    //     const newCards = Array.isArray(action.payload.data?.data)
    //       ? action.payload.data.data.filter(
    //           (newCard) => !state.data.masterCard.some((existing) => existing.id === newCard.id)
    //         )
    //       : [];
    //     console.log('Pushing MasterCard data:', newCards); // Debug log
    //     state.data.masterCard.push(...newCards);
    //   })
    //   .addCase(getMasterCardData.rejected, (state, action) => {
    //     state.status = 'failed';
    //     state.error = action.error.message;
    //   });
    // .addCase(createCryptoWallet.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(createCryptoWallet.fulfilled, (state, action) => {
    //   const newWallet = Array.isArray(action.payload.wallet)
    //     ? action.payload.wallet.filter(
    //         (newCard) => !state.data.masterCard.some((existing) => existing.id === newCard.id)
    //       )
    //     : [];       
    //   state.data.cryptoWallets.push(...newWallet);
    // })
    // .addCase(createCryptoWallet.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error.message;
    // });
  },
});

// export const { increment, decrement, incrementByAmount } = mainWalletsSlice.actions;
export default settingSlice.reducer;